import { HelpTooltip } from '../common/HelpTooltip';
import { cn } from '../../utils/cn';

/**
 * `.pen` → `ds/label/section-heading`: linha horizontal (`gap $space-2`,
 * centrada) com o título em `$type-section` 700 uppercase, uma dica opcional em
 * `$type-chip` e um ícone `info` de 14px — tudo em `$fg-muted`.
 *
 * A dica só existe em mobile por omissão (nos frames 768/1280 o nó `h` está
 * desligado); `desktopTitle` troca o título a partir de `md` (ex.: «Grupos do
 * método»). Passa `hintAlways` quando o `.pen` mantém a dica visível em todos
 * os breakpoints (ex.: cabeçalho "OS TEUS ATIVOS" em Ativos).
 */
export function ExpensesSectionLabel({ title, desktopTitle, hint, tooltip, hintAlways = false }) {
  return (
    <div className="flex w-full min-w-0 items-center gap-space-2 text-muted-foreground">
      {desktopTitle ? (
        <>
          <span className="type-section md:hidden">{title}</span>
          <span className="type-section hidden md:inline">{desktopTitle}</span>
        </>
      ) : (
        <span className="type-section">{title}</span>
      )}

      {hint ? (
        <span className={cn('type-chip min-w-0 font-normal', !hintAlways && 'md:hidden')}>
          {hint}
        </span>
      ) : null}

      {tooltip ? (
        <HelpTooltip appearance="plain" label={tooltip} content={tooltip} />
      ) : null}
    </div>
  );
}

export default ExpensesSectionLabel;
